"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderSurveyText = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const useRenderSurveyText = () => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    return {
        render: ({ id, translationKey, render }) => {
            if (render) {
                return render({ id, translationKey });
            }
            return translate(translationKey);
        },
    };
};
exports.useRenderSurveyText = useRenderSurveyText;
//# sourceMappingURL=useRenderSurveyText.js.map